import { useEffect, useRef } from "react";
import { sendAuctionExposureEvent } from "../commons/LanderEvent";
import { LanderConfig } from "../types/LanderConfig";

interface AuctionDetailsRedirectProps {
  to: string;
  landerConfig: LanderConfig;
}

// PARKING-5212 treatment_c: pre-render redirect to the Auctions Domain Details
// page. Beacons the exposure then replaces the history entry so the back button
// doesn't loop back into the lander.
export function AuctionDetailsRedirect({
  to,
  landerConfig,
}: AuctionDetailsRedirectProps) {
  const firedRef = useRef(false);
  useEffect(() => {
    if (firedRef.current) return;
    firedRef.current = true;
    sendAuctionExposureEvent(landerConfig, { beacon: true });
    window.location.replace(to);
  }, [to, landerConfig]);

  return null;
}
